import type { Asserts } from 'yup';

import { contractSchema as pkwContractSchema } from '@/features/Sparten/pkwv2/schema/contractSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const contractSchema = pkwContractSchema;

export type ContractStore = Asserts<typeof contractSchema>;

export const usePkwv2ContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'Pkwv2ContractStore',
);
